import _ from "lodash";

// constant
import { INSTANCE_URL, COMMON_MODAL_PAYLOAD } from "@constant";
import { getRequest, postRequest } from "@network";
import { detectBrowser } from "@utilscommon";

export const EVENT = "EVENT";
export const EVENT_LANGUAGES = "EVENT_LANGUAGES";
export const EVENT_SETTINGS = "EVENT_SETTINGS";
export const EVENT_INTERESTS = "EVENT_INTERESTS";
export const USER_CATEGORY = "USER_CATEGORY";
export const STRIPE_CHARGES_LIST = "STRIPE_CHARGES_LIST";
export const STRIPE_CONNECTION = "STRIPE_CONNECTION";
export const EVENT_APPUSER_COUNT = "EVENT_APPUSER_COUNT";
export const FORCE_REFRESH = "FORCE_REFRESH";
export const COMMON_MODAL = "COMMON_MODAL";
export const COUNTRY_LIST = "COUNTRY_LIST";

export const checkEvent = (session, seocode, callback) => {
  // seocode = "phone";
  // console.log("seocode checkEvent: ", seocode);

  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public/fetcheventbyseocode`;
  let body = { seocode: seocode };

  return (dispatch) => {
    if (
      session.seocode &&
      session.seocode !== "" &&
      session.seocode.toLowerCase() !== seocode.toLowerCase()
    ) {
      dispatch({ type: EVENT, payload: {} });
    }
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (!_.isEmpty(response?.resource?.eventinfo)) {
          // ----- event and event-details set
          dispatch({ type: EVENT, payload: response.resource.eventinfo });

          // ----- event theme color set to root
          // var root = document.querySelector(':root');
          let root = document.documentElement;
          root.style.setProperty(
            "--theme_color",
            response.resource.eventinfo.themecolor
          );
          root.style.setProperty(
            "--theme_color_light",
            `${response.resource.eventinfo.themecolor}dd`
          );

          callback({ success: 1, resource: response.resource.eventinfo });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventLanguages = (session, eventid, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public/fetcheventlanguages`;
  let body = { eventid: session?.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: EVENT_LANGUAGES,
          payload: response?.resource?.languages ?? [],
        });
        callback({ success: 1, resource: response?.resource?.languages ?? [] });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventSettings = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public/fetcheventsettings`;
  let body = { eventid: session?.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        let ES = !_.isEmpty(response?.resource?.eventsettings)
          ? response?.resource?.eventsettings
          : {};

        dispatch({ type: EVENT_SETTINGS, payload: { data: ES } });
        callback({ success: 1, data: ES });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventInterests = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public/fetcheventinterests`;
  let body = { eventid: session?.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: EVENT_INTERESTS,
          payload: { data: response?.resource },
        });
        callback({ success: 1, data: response?.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};
export const fetchUserCategory = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public/fetchusercategory`;
  let body = { eventid: session?.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: USER_CATEGORY,
          payload: { data: response?.resource },
        });
        callback({ success: 1, data: response?.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchStripeCharges = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/stripe_currency`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: STRIPE_CHARGES_LIST,
          payload: { data: response?.resource },
        });
        callback({ success: 1, data: response?.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchStripeConnection = (session, callback) => {
  let fields = "gateway,stripeaccountid";
  let filter = encodeURI(`eventid=${session?.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/ticket_stripe?fields=${fields}&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: STRIPE_CONNECTION,
          payload: { data: response?.resource?.[0] ?? {} },
        });
        callback({ status: 1, data: response?.resource?.[0] ?? {} });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchAppuserCount = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public`;
  let body = { ...data, type: "appusercount" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        dispatch({
          type: EVENT_APPUSER_COUNT,
          payload: { data: response },
        });
        callback({ success: 1, data: response });
      },
      (error) => {
        dispatch({ type: EVENT_APPUSER_COUNT, payload: { data: [] } });
        callback({ success: 0, error: error });
      }
    );
  };
};

export const supportTicketRelated = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "supportticketrelated" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1 });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const toggleRefresh = (value) => {
  return (dispatch) => {
    dispatch({ type: FORCE_REFRESH, payload: value });
  };
};

export const contactRelated = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "contactunsubscribe" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1 });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const setCommonModal = (values) => {
  let payload = !_.isEmpty(values) ? values : _.cloneDeep(COMMON_MODAL_PAYLOAD);

  return (dispatch) => {
    dispatch({ type: COMMON_MODAL, payload });
  };
};

export const postAnalytics = (session, payload, callback = () => {}) => {
  const { options, ticketcode, trackingcode, formid } = payload;
  const {
    type,
    dfid = 0,
    screen = "registration",
    associatedid = null,
    searchtext = null,
    hassearchresult = 0,
  } = options;

  const body = {
    ticketcode,
    trackingcode,
    formid,
    type: "postLinkAnalytics",
    eventid: session.eventid,
    analyticsData: {
      dfid,
      screen,
      type,
      associatedid,
      searchtext,
      hassearchresult,
      eventid: session.eventid,
      data: JSON.stringify({
        ...detectBrowser(),
        eventid: session.eventid,
      }),
    },
  };

  return (dispatch) =>
    postRequest(
      `${INSTANCE_URL}/api/v2/ticketrelated`,
      body,
      session,
      dispatch,
      (response) => callback(response),
      (error) => callback({ success: 0 })
    );
};

export const fetchAssociatedAttendee = (
  session,
  payload,
  callback = () => {}
) => {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...payload, type: "fetchassociatedattendee" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchCountryList = (session, callback) => {
  let filter = encodeURIComponent(`isactive=1`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/countrylist?filter=(${filter})&order=country`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response?.resource });
        dispatch({ type: COUNTRY_LIST, payload: response?.resource });
      },
      (error) => {
        callback({ success: 0, data: [] });
      }
    );
  };
};
